// extracted by mini-css-extract-plugin
export default {"leaderShip":"leadership_leaderShip__FwKL0","title":"leadership_title__kLVXe","items":"leadership_items__CWE6P","imgWrapper":"leadership_imgWrapper__uGym9"};